import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { NbToastrService } from "@nebular/theme";
import { ApiServiceService } from "../../api-service.service";

@Component({
  selector: "ngx-superlogin",
  templateUrl: "./superlogin.component.html",
  styleUrls: ["./superlogin.component.scss"],
})
export class SuperloginComponent implements OnInit {
  // @ViewChild("backgroundVideo") backgroundVideo: ElementRef;

  username: string;
  password: string;
  rememberMe: boolean;
  showPassword: boolean = false;
  loading: boolean = false;
  errorMessage: string = "";

  slideshowImages: string[] = [
    // "/assets/images/Login 1.jpeg",
    "/assets/images/Login 2.jpeg",
    "/assets/images/Login 3.jpeg",
  ];
  slideIndex: number = 0;
  constructor(
    private toastrService: NbToastrService,
    private apiService: ApiServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const el = document.getElementById("nb-global-spinner");
    if (el) {
      el.style["display"] = "none";
    }
    this.showSlides();
  }
  showSlides(): void {
    setInterval(() => {
      this.slideIndex++;
      if (this.slideIndex >= this.slideshowImages.length) {
        this.slideIndex = 0;
      }
    }, 3000);
  }
  login() {
    if (!this.username || !this.password) {
      this.errorMessage = "Please enter both username and password.";
      return;
    }

    const formdata = {
      UserName: this.username,
      Password: this.password,
    };

    this.apiService.adminLogin(formdata).subscribe(
      (response: any) => {
        if (response.message === "Login Successfully.") {
          if (
            response.UserType === "Web" ||
            response.UserType === "SuperAdmin"
          ) {
            // Navigate to the appropriate dashboard based on UserType
            if (response.UserType === "SuperAdmin") {
              // this.router.navigate(["pages/dashboard"]);
              this.router.navigate(["/pages/layout/stepper"]);
            } else {
              this.router.navigate(["pages/forms/inputs"]);
            }
          } else {
            this.errorMessage = "You are not authorized to login.";
          }
        } else if (response.message === "User is not active.") {
          this.errorMessage =
            "User is not active. Please contact the administrator.";
        } else {
          this.errorMessage = "Invalid Username or User Type.";
        }
      },
      (error: any) => {
        console.error("Error during login:", error);
        this.errorMessage = "Invalid Password  Enter Valid Password ";
      }
    );
  }

  cancelLogin() {
    console.log("Login cancelled.");
  }

  forgotPassword() {
    this.router.navigate(["/auth/forgotpassword"]);
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
